/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { isEmpty, isFunction } from 'lodash';

// Components
import ProgressRing from 'shared/ui/components/ProgressRing.vue';

// Constants
const WorkerScope = window.SharedWorker ? MessagePort : Worker;

const __vue_script__ = {
    name: 'UploadProgress',

    components: { ProgressRing },

    props: {
        upload: {
            type: Object,
            required: true
        },

        workerScope: {
            type: WorkerScope,
            default: () => null
        },

        fpType: {
            type: String,
            default: null
        }
    },

    data() {
        return {
            canceled: false,
            error: null,
            progress: null,
            status: 0,
            messageListener: null,
            started: false,
            unsubscribeListener: null
        };
    },

    computed: {
        /** @returns {boolean} */
        running() {
            return this.started && this.progress !== 100 && !this.hasError && !this.canceled;
        },

        /** @returns {boolean} */
        completed() {
            return this.status === 200 || this.hasError || this.canceled;
        },

        /** @returns {boolean} */
        hasError() {
            return !isEmpty(this.error);
        }
    },

    watch: {
        workerScope: {
            immediate: true,
            handler() {
                if (!this.workerScope || this.completed) return;
                this.messageListener = this.handleWorkerMessage.bind(this);
                this.workerScope.addEventListener('message', this.messageListener);
            }
        }
    },

    beforeDestroy() {
        this.tearDown();
    },

    methods: {
        /**
         * @param {MessageEvent} event
         */
        async handleWorkerMessage(event) {
            const currentId = this.upload.id;
            const response = event.data;
            const data = response[response.type];
            const receivedId = data.id || response.id;

            if (currentId !== receivedId) {
                return;
            }

            switch (response.type) {
                case 'error':
                    this.tearDown();
                    this.error = response;
                    this.$emit('error', response);

                    break;

                case 'status': {
                    if (data === 'canceled') {
                        this.tearDown();
                        this.canceled = true;
                        this.$emit('canceled');
                    }

                    break;
                }

                case 'progress': {
                    if (!this.started && data.percent !== 0) {
                        this.started = true;
                        this.$emit('started');
                    }

                    this.progress = data.percent;
                    this.$emit('progress', data.percent);

                    break;
                }

                case 'result': {
                    if (this.fpType) {
                        const channel = `document/${this.fpType}/update`;
                        const handler = signal => {
                            if (signal.targetId !== data.id) {
                                return;
                            }
                            console.debug('[UploadProgress] Upload completed and processed', signal);
                            this.complete(data, signal.document);
                        };
                        this.unsubscribeListener = await this.$services.signal.addSignalListener(channel, handler);
                    } else {
                        this.complete(data);
                    }
                    break;
                }
            }
        },

        complete(data, document) {
            this.tearDown();
            this.status = data.status;
            this.$emit('completed', data, document);
        },

        cancel() {
            console.info('[UploadProgress] Aborting upload:', this.upload);

            this.$modal.show('dialog', {
                text: this.$t('media.uploads.confirm_abort', [this.upload.file.name]),
                buttons: [
                    {
                        title: this.$t('general.cancel'),
                        default: true,
                        class: 'btn'
                    },
                    {
                        title: this.$t('general.confirm'),
                        handler: () => {
                            this.$modal.hide('dialog');
                            this.$emit('abort');
                        },
                        class: 'btn btn-danger'
                    }
                ]
            });
        },

        tearDown() {
            if (this.workerScope && this.messageListener) {
                this.workerScope.removeEventListener('message', this.messageListener);
            }

            if (isFunction(this.unsubscribeListener)) {
                this.unsubscribeListener();
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload-progress",class:{ canceled: _vm.canceled }},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.upload.file.name))]),(_vm.running)?_c('div',{staticClass:"actions"},[_c('a',{staticClass:"cancel has-action",on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.$t('general.cancel')))])]):_vm._e(),_c('div',{staticClass:"status"},[(_vm.running)?_c('progress-ring',{staticClass:"primary",attrs:{"progress":_vm.progress,"stroke":4}}):_vm._e(),(_vm.completed)?_c('div',{staticClass:"completed",class:{ error: _vm.hasError || _vm.canceled }},[(!_vm.hasError && !_vm.canceled)?_c('i',{staticClass:"ic-check"}):_c('i',{staticClass:"ic-x"})]):_vm._e(),(!_vm.running && !_vm.completed)?_c('loader',{attrs:{"status":true}}):_vm._e()],1)])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "UploadProgress.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__